import {Modal2} from "../modal";
import React from "react";
import {Action} from "../../funcs/utils";


const ContribErrorDialog = props => {
  const div_style = {
    fontSize: "1.5rem",
  }
  const component = props.component;
  const on_close = () => {
    component.setState({
      contribution_error_dialog: false,
    })
  }
  const error_msg = "Enter a value greater than zero";
  return (<Modal2
    container_style={{width: "40rem"}}
    show={true}
    onDismiss={on_close}
    onClose={on_close}
    noFooter={true}>
    <div align={"center"} style={div_style}>
      <span>{error_msg}</span>
      <div style={{height: "3rem"}}/>
      <Action onClick={on_close}>
        Ok
      </Action>
    </div>
  </Modal2>);
}

export { ContribErrorDialog }
